import { defineComponent as _defineComponent } from 'vue'
import VModal from "@/components/vModal.vue";
import { useTranslations } from "@/hooks/useTranslations";
import {ref, watch} from "vue";
import IngredientCostRepository from "@/utils/API/IngredientCostRepository";

type vAdditionalMeasurementModalProps = {
  show: boolean,
  cost: any,
}


export default /*#__PURE__*/_defineComponent({
  __name: 'vAdditionalMeasurementModal',
  props: {
    show: { type: Boolean },
    cost: null
  },
  emits: ['close', 'save'],
  setup(__props: any, { emit }) {

const props = __props as {
  show: boolean,
  cost: any,
};



const newMeasurements = ref<{ name: string; weight: number }[]>([]);
const translations = useTranslations();
const loading = ref(false);
watch(
  () => props.show,
  (val) => {
    if (val) {
      fetchAdditionalMeasurementsForCost();
    }
  }
);

async function fetchAdditionalMeasurementsForCost() {
  const isEdit = Boolean(props.cost.id);
  newMeasurements.value = [getEmptyMeasurement()];
  loading.value = true;

  try {
    const response = await IngredientCostRepository.loadMeasurementsForIngredientCost({
      id: isEdit ? props.cost.id : null,
      name: props.cost.name,
      measurements: props.cost.ingredientCostMeasurements.map((x: any) => ({
        id: x.measurement.id,
        name: x.measurement.name,
        weightInGrams: x.weightInGrams,
      })),
    });

    if (response.data.result.length) {
      newMeasurements.value = response.data.result.map((x: any) => ({
        name: x.name,
        weight: (Math.round(x.weightInGrams * 100) / 100).toFixed(2),
      }));
    }
    newMeasurements.value.push(getEmptyMeasurement());
  }
  catch (error) {
    console.error("Failed to load measurements", error);
  }
  finally {
    loading.value = false;
  }
}

const getEmptyMeasurement = () => ({
  name: "",
  weight: 0,
});

const addRow = () => {
  newMeasurements.value.push(getEmptyMeasurement());
};

const removeRow = (index: number) => {
  newMeasurements.value.splice(index, 1);
};



return { __sfc: true,props, emit, newMeasurements, translations, loading, fetchAdditionalMeasurementsForCost, getEmptyMeasurement, addRow, removeRow, VModal }
}

})